import {
  useSafeAreaInsets,
  useSafeAreaFrame,
} from 'react-native-safe-area-context';
import {getDefaultHeaderHeight} from '@react-navigation/elements';
import useResponsiveDimensions from './useResponsiveDimensions';

/**
 * Custom hook to retrieve the default header height for a screen.
 *
 * @returns {number} The computed default header height.
 */
export const useCustomHeaderHeight = (isModal?: boolean): number => {
  // Get safe area insets (e.g., for devices with notches)
  const {top: topInset} = useSafeAreaInsets();
  const {isMobile} = useResponsiveDimensions();

  // Get screen dimensions (frame)
  const frame = useSafeAreaFrame();

  // Compute custom header height (false = not modal)
  return (
    getDefaultHeaderHeight(frame, !!isModal, topInset) * (isMobile ? 1 : 1.2)
  );
};
